import FuseAnimate from '@fuse/core/FuseAnimate';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Where somebody lands when they are signed in but the page is not theirs to open.
 *
 * Until now that case was sent quietly to the home page, which is indistinguishable
 * from a broken link — people reported it as one. Saying so plainly is both kinder and
 * a great deal easier to support.
 *
 * The wording deliberately does not name what is behind the door, and points at the
 * administrator rather than at a support address: what somebody may reach is a
 * decision inside this company, not a fault to report.
 */
function Error403Page() {
  return (
    <div className="flex flex-col flex-1 items-center justify-center p-16">
      <div className="max-w-512 text-center">
        <FuseAnimate animation="transition.expandIn" delay={100}>
          <Typography variant="h1" color="inherit" className="font-medium mb-16">
            403
          </Typography>
        </FuseAnimate>

        <FuseAnimate delay={500}>
          <Typography variant="h5" color="textSecondary" className="mb-16">
            You don&apos;t have access to this page
          </Typography>
        </FuseAnimate>

        <FuseAnimate delay={500}>
          <Typography variant="body2" color="textSecondary" className="mb-32">
            If you think you should, ask an administrator to check your role.
          </Typography>
        </FuseAnimate>

        <Link className="font-medium" to="/">
          Go back to Home
        </Link>
      </div>
    </div>
  );
}

export default Error403Page;
